const routes = {
  
    list: "/list",
    dashboard: "/dashboard/:category/:id"
}

export default routes;